import React from 'react';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import Error from 'components/InPersonTraining/shared/Error';
import NotFoundSvg from './svg/NotFoundSvg';
import NeedPermissionSvg from './svg/NeedPermissionSvg';

const ContentError = ({ error }) => {
  let image;
  let title;
  let subHeader;
  if (error === 401) {
    image = <NeedPermissionSvg />;
    title = t('questions.types.content.need_permisson_title');
    subHeader = t('questions.types.content.need_permisson_subtext');
  } else if (error === 404) {
    image = <NotFoundSvg className="mb-20" />;
    title = t('questions.types.content.not_found_title');
    subHeader = t('questions.types.content.not_found_subtext');
  } else {
    return (
      <div className="ContentError">
        <Error />
      </div>
    );
  }
  return (
    <div className="ContentError">
      {image}
      <Text
        variant={TEXT_VARIANTS.TITLE_BOLD}
        className="mb-4 ContentError--text"
      >
        {title}
      </Text>
      <Text variant={TEXT_VARIANTS.BODY_LIGHT} className="ContentError--text">
        {subHeader}
      </Text>
    </div>
  );
};

export default ContentError;
